import { ID, idDef } from "@kosmod/kit"
import { s } from "@kosmod/pancake";
import { AccountID } from "./account";

export type GameID = ID<"game", true>;
export const GameID = s.ref<GameID>()(idDef);

export type Game = {
  id: GameID,

  name: string,

  owner: AccountID,
}

export const Game = s.ref<Game>()(s.o({
  id: GameID,

  name: s.str,

  owner: AccountID,
}));
